import React from 'react';
import { motion } from 'framer-motion';
import { FaYoutube, FaInstagram } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="border-t-4 border-black py-12 md:py-16" style={{ background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)' }}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold font-heading text-black mb-2" style={{ fontFamily: "'Bangers', cursive" }}>AI Gaming Girl</h3>
            <p className="text-gray-800" style={{ fontFamily: "'Fredoka One', cursive" }}>Fun AI & IoT projects for everyone!</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold font-heading text-black mb-4" style={{ fontFamily: "'Bangers', cursive" }}>Pages</h4>
            <div className="flex flex-col gap-3 text-gray-800">
              <a href="/" className="hover:text-purple-600 transition-colors font-medium" style={{ fontFamily: "'Fredoka One', cursive" }}>Home</a>
              <a href="/about" className="hover:text-purple-600 transition-colors font-medium" style={{ fontFamily: "'Fredoka One', cursive" }}>About Me</a>
              <a href="/my-games" className="hover:text-purple-600 transition-colors font-medium" style={{ fontFamily: "'Fredoka One', cursive" }}>My Games</a>
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-lg font-bold font-heading text-black mb-4" style={{ fontFamily: "'Bangers', cursive" }}>Connect</h4>
            <div className="flex gap-4">
              <motion.a
                href="https://www.youtube.com/@theaigaminggirl"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2 }}
                className="text-2xl text-gray-800 hover:text-red-600 transition-colors"
              >
                <FaYoutube />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/aigaminggirl/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2 }}
                className="text-2xl text-gray-800 hover:text-pink-600 transition-colors"
              >
                <FaInstagram />
              </motion.a>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-black pt-8 text-center text-gray-800" style={{ fontFamily: "'Fredoka One', cursive" }}>
          <p>&copy; 2026 AI Gaming Girl. All rights reserved. 🎮✨</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
